var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16698 15C1.45865 15 0.955178 14.684 0.656566 14.0521C0.357955 13.4201 0.430872 12.8333 0.875316 12.2917L5.50032 6.66667V1.66667H4.66698C4.43087 1.66667 4.23296 1.58681 4.07323 1.42708C3.91351 1.26736 3.83365 1.06944 3.83365 0.833333C3.83365 0.597222 3.91351 0.399306 4.07323 0.239583C4.23296 0.0798611 4.43087 0 4.66698 0H11.3337C11.5698 0 11.7677 0.0798611 11.9274 0.239583C12.0871 0.399306 12.167 0.597222 12.167 0.833333C12.167 1.06944 12.0871 1.26736 11.9274 1.42708C11.7677 1.58681 11.5698 1.66667 11.3337 1.66667H10.5003V6.66667L15.1253 12.2917C15.5698 12.8333 15.6427 13.4201 15.3441 14.0521C15.0455 14.684 14.542 15 13.8337 15H2.16698ZM2.16698 13.3333H13.8337L8.83365 7.25V1.66667H7.16698V7.25L2.16698 13.3333Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting);
export default __webpack_public_path__ + "static/media/testing.b37fb5652a73caec14ae9940d63407d0.svg";
export { ForwardRef as ReactComponent };